var _rect, _rect2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSauces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Glyph_Icon",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Glyph Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 37.971,
    rx: 3,
    width: 22.42,
    x: 29.28,
    y: 20.694
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 4.368,
    rx: 1,
    width: 10.277,
    x: 17.177,
    y: 9.978
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.259 15.905c0-.552-.448-1-1-1h-2.001l-2.132-8.911c-.092-.386-.438-.659-.835-.659h-1.603c-.397 0-.743.272-.835.659l-2.132 8.911h-2.001c-.552 0-1 .448-1 1v2.789h13.538v-2.789z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.28 25.935-1.117-9.589h-7.695l-1.32 11.334c-.035.304-.251.549-.539.653-4.188 1.5-4.309 6.118-4.309 6.118v1.09h14.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.3 37.542h14.98v12.981h-14.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.28 52.523h-14.98v4.574c0 .866.702 1.568 1.568 1.568h14.438c-.634-.838-1.025-1.87-1.025-3v-3.142z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauces);
export default __webpack_public_path__ + "static/media/sauces.ba38c2c58cb974c724d6da0c50102ea8.svg";
export { ForwardRef as ReactComponent };